<div class="masthead-benefits-sleeve">
  <div class="page-content-sleeve">
    <!-- Self Service Toolbar -->
    @if (helperService.isSelfServiceSite) {
      <div class="m-t-8">
        <app-editable-mbr-site-toolbar [instance]="this"
          [header]="{ label: resourcestrings['Aon.SelfService.MastheadBenefits.EntityToolbar.Header.Label'] }" [wrapperClass]="'bg-color-site-header'"
          [controls]="entityToolbarControl" (dropdownState)="onEntityDropdownStateChange($event)"></app-editable-mbr-site-toolbar>
      </div>
    }

    @if (resourcestrings['Aon.Navigation.ProductsIntro']) {
      <h4
        class="col-lg-12 m-b-40 m-t-28 d-none d-lg-block color-2"
        [innerHTML]="resourcestrings['Aon.Navigation.ProductsIntro'] | striphtml"
        [attr.aria-label]="resourceStrings['Aon.Navigation.ProductsIntro']">
      </h4>
    }
    <div class="navbar navbar-expand-lg navbar-collapsed m-l-0 p-l-0 p-r-0">
      <ng-template #categoryNameTemplate let-category="category">
        @if (category.categoryName == '') {
          <i aria-hidden="true" class="fas fa-eye-slash m-r-8"></i>
          <span [innerHTML]="resourcestrings['Aon.SelfService.MastheadBenefits.HiddenCategory'] | safeHtml"></span>
        } @else {
          @if (category.icon) {
          <img src="{{category.icon}}" alt="" class="benefit-tab-icon">
          }{{category.categoryName}}
        }
      </ng-template>
      <!--Mobile-->
      <div class="d-md-block d-lg-none w-100">
        <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav navbar-nav p-l-0 m-l-0 w-100">
          @for (category of benefits; track category; let sectionIndex = $index) {
            <li class="nav-item-dropdown"
              [ngbNavItem]="sectionIndex">
              <a ngbNavLink class="d-flex justify-content-between tab-link w-tab-link w-100"
                 href="javascript:void(0)" role="tab" (click)="setCategoryIndex(sectionIndex, $event)" >
                <div class="content-left-container d-flex">
                  <ng-container *ngTemplateOutlet="categoryNameTemplate; context: { category: category }"></ng-container>
                </div>
                <i class="float-end aon-icon aon-menu-collapse m-l-5 d-lg-none" aria-hidden="true"></i>
              </a>
              <ng-template ngbNavContent>
                @if (category) {
                  <ng-container [ngTemplateOutlet]="innerTabset" [ngTemplateOutletContext]="{currentCategory:category}"></ng-container>
                }
              </ng-template>
              @if (categoryIndex == sectionIndex && categoryToggle) {
                <div class="masthead-products-sleeve page-content-sleeve" id="benefits" role="tab">
                  <div [ngbNavOutlet]="nav"></div>
                </div>
              }
            </li>
          }
        </ul>
      </div>

      <!--Desktop-->
      <div class="d-none d-lg-block">
        <ul ngbNav #desktopNav="ngbNav" [(activeId)]="active" class="nav navbar-nav p-l-0 m-l-0 w-100">
          @for (category of benefits; track category; let sectionIndex = $index) {
            <li class="nav-item-dropdown"
              [ngbNavItem]="sectionIndex">
              <a ngbNavLink class="d-flex tab-link w-tab-link w-100"
                 href="javascript:void(0)" role="tab" (click)="setCategoryIndex(sectionIndex, $event)">
               <ng-container *ngTemplateOutlet="categoryNameTemplate; context: { category: category }"></ng-container>
              </a>
              <ng-template ngbNavContent>
                @if (category) {
                  <ng-container [ngTemplateOutlet]="innerTabset" [ngTemplateOutletContext]="{currentCategory:category}"
                  ></ng-container>
                }
              </ng-template>
            </li>
          }
        </ul>
      </div>

    </div>
  </div>
  <div class="divider d-lg-block d-none"></div>

  <ng-template #innerTabset let-currentCategory='currentCategory'>
    <div class="mobile-sub-nav-content d-flex d-lg-none">
      <a href="javascript:void(0)" [attr.aria-label]="resourcestrings['Aon.Arialabel.Toggle']" (click)="showCategory(false)">
        <i class="fal fa-chevron-left m-r-8" aria-hidden="true"></i>
        @if (currentCategory.categoryName == '') {
        <i aria-hidden="true" class="fas fa-eye-slash m-r-8"></i>
        } @else if(currentCategory.icon) {
        <img src="{{currentCategory.icon}}" alt="">
        }
      </a>
      @if (currentCategory.categoryName == '') {
        <p class="strong m-b-0" [innerHTML]="resourcestrings['Aon.SelfService.MastheadBenefits.HiddenCategory'] | safeHtml"></p>
      } @else {
        <p class="strong m-b-0">{{currentCategory.categoryName}}</p>
      }
    </div>
    <div class="product-description">
      @if (currentCategory.categoryName == '') {
      <i aria-hidden="true" class="fas fa-eye-slash hidden-category-icon"></i>
      } @else if (currentCategory.icon2) {
      <img src="{{currentCategory.icon2}}" class="d-none d-lg-block" alt="">
      }
      <p [innerHTML]="resourcestrings['Aon.MastHeadBenefit.Description'] | safeHtml"></p>
    </div>
    @if (currentCategory && currentCategory.groupBenefits) {
      <div class="row">
        @for (product of currentCategory.groupBenefits; track product; let i = $index) {
          @if (currentCategory.groupBenefits.length < 7 || i < 5 || currentCategory.categoryName == showAllForCategory) {
            <div class="grid-col d-flex col-12 col-sm-6 col-lg-4">
              <div class="product-card-body-wrapper basic-card">
                @if (helperService.isSelfServiceSite) {
                <app-editable-mbr-site-toolbar [instance]="this" (refreshContent)="refreshBenefits()" [isInsideCard]="true" [wrapperClass]="'bg-color-site-header'"
                    [header]="{ label: product.documentName, managedBy: product?.isFromExternalInstance ? ContentManagedBy.ExternalEditor : ContentManagedBy.InternalEditor, hasOverlays: product?.requirementsOverlay, hasPendingStagingTaskNodeIDs: product?.pendingStagingTaskNodeIDs?.length > 0, populations: helperService.roleConditionToPopulationsConversion(product?.roleCondition), isExcludedForCulture: product?.isExcluded }" [isSoftDeleted]="product?.isSoftDeleted"
                    [controls]="instanceToolbarControl[product.nodeGUID]"  (dropdownState)="onInstanceDropdownStateChange($event)">
                  </app-editable-mbr-site-toolbar>
                }
                <div class="product-card-body">
                  <h2 class="product-name m-b-12 theme-color h3" [innerHTML]="product.itemTitle | safeHtml">
                    <span [innerHTML]="product.itemTitle | safeHtml" class="p-0"></span>
                  </h2>
                  <p class="d-inline m-r-5" [innerHTML]="product.itemSummary | safeHtml"></p>
                  @if (!product.hideProductDetails) {
                  <a class="d-inline-block group-benefit-cards-{{i}}" (keyup.enter)="navigateToProductDetail(product)"
                     (click)="navigateToProductDetail(product)" [routerLink]=""  tabindex="0">
                    {{resourcestrings['Aon.BenefitMatrix.ViewBenefitInformation']}}<span class="visually-hidden">
                      - {{product.itemTitle}}
                    </span>
                  </a>
                  }
                </div>
              </div>
            </div>
          }
          @if ((currentCategory.groupBenefits.length > 6 && i == 6) && currentCategory.categoryName != showAllForCategory) {
            <div class="grid-col d-flex col-12 col-sm-6 col-lg-4">
              <div class="basic-card d-flex align-items-center">
                <p class="h3 theme-color"><a class="p-0" (keyup.enter)="showAllCards(currentCategory.categoryName, i)"
                  (click)="showAllCards(currentCategory.categoryName, i)" [routerLink]="">{{resourcestrings['Aon.MastHeadBenefit.ViewAll']}} @if (currentCategory.categoryName == '') { {{resourcestrings['Aon.SelfService.MastheadBenefits.HiddenCategory']}} } @else { {{currentCategory.categoryName}} }</a></p>
              </div>
            </div>
          }
        }
      </div>
    }
  </ng-template>
  <div class="d-none d-lg-block masthead-products-sleeve page-content-sleeve">
    <div [ngbNavOutlet]="desktopNav"></div>
  </div>
</div>
